import { c as _c } from "react/compiler-runtime";
import type { SaveItemRequest } from "@sticker-giant/sg-frontend-common";
import { useMutation } from "@tanstack/react-query";
import { useServicesStore } from "@/stores/useServicesStore";
export const saveForLaterMutationKey = ["saveForLater"] as const;
export const useSaveForLater = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationKey: [...saveForLaterMutationKey],
      mutationFn: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};
async function _temp(request) {
  const {
    cartClient
  } = useServicesStore.getState();
  if (!cartClient) {
    throw new Error("Cart client is not initialized");
  }
  return cartClient.saveItem(request);
}